export const setZero = () => {
  document.getElementById("notes").value = "";
  document.getElementById("width").value = "";
  document.getElementById("height").value = "";
  document.getElementById("qty").value = "";
};
